<div id="content" class="allcp-form" ng-controller="UserController" ng-init="init()">
    <div ng-include="'modules/company/menus/setting_menu.html'"></div>
    <div class="panel-body">
        <div class="table-responsive" ng-if="data.users.data.length > 0">
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead class="p20">
                    <tr class="bg-light">
                        <th class="text-center w75"></th>
                        <th>
                            <a href="#" ng-click="sortType = 'full_name'; sortReverse = !sortReverse">
                                Full Name
                                <span ng-show="sortType == 'full_name' && !sortReverse" class="fa fa-caret-down"></span>
                                <span ng-show="sortType == 'full_name' && sortReverse" class="fa fa-caret-up"></span>
                            </a>
                        </th>
                        <th>
                            <a href="#" ng-click="sortType = 'email'; sortReverse = !sortReverse">
                                E-Mail
                                <span ng-show="sortType == 'email' && !sortReverse" class="fa fa-caret-down"></span>
                                <span ng-show="sortType == 'email' && sortReverse" class="fa fa-caret-up"></span>
                            </a>
                        </th>
                        <!--<th>Ekip</th>-->
                        <!-- <th>Owner</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-left" ng-repeat="item in data.users.data | filter: data.term | orderBy:sortType:sortReverse ">
                        <td class="text-center">
                            <label class="option block mn" ng-if="authenticatedUser.owner">
                                <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <!-- <td class="clickable-row" ng-click="goToUser(item.id)">{{ item.id }}</td> -->
                        <td class="clickable-row" ng-click="openDetail(item)">
                            {{ item.full_name }} <br>
                            <span ng-if="item.owner" class="label label-primary">Owner</span>
                        </td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.email }}</td>
                        <!--
							<td class="clickable-row" ng-click="goToUser(item.id)">
								<span ng-repeat="team in item.teams">{{ team.name }} <span ng-if="!$last">,</span> </span>
							</td>
							-->
                        <!-- <td class="clickable-row w200" ng-click="goToUser(item.id)">
                            <dl class="dl-horizontal list-dt-color mn text-center">
                                <dt>Saha Yönetimi : </dt>
                                <dd>
                                    <i class="fa fa-plus text-success" ng-if="item.authorization.maps"></i>
                                    <i class="fa fa-minus text-danger" ng-if="!item.authorization.maps"></i>
                                </dd>
                                <dt>Ofis Yönetimi : </dt>
                                <dd>
                                    <i class="fa fa-plus text-success" ng-if="item.authorization.office"></i>
                                    <i class="fa fa-minus text-danger" ng-if="!item.authorization.office"></i>
                                </dd>
                                <dt>Müşteri Yönetimi : </dt>
                                <dd>
                                    <i class="fa fa-plus text-success" ng-if="item.authorization.customers"></i>
                                    <i class="fa fa-minus text-danger" ng-if="!item.authorization.customers"></i>
                                </dd>
                                <dt>Kullanıcı Yönetimi : </dt>
                                <dd>
                                    <i class="fa fa-plus text-success" ng-if="item.authorization.users"></i>
                                    <i class="fa fa-minus text-danger" ng-if="!item.authorization.users"></i>
                                </dd>
                                <dt>Rapor Yönetimi : </dt>
                                <dd>
                                    <i class="fa fa-plus text-success" ng-if="item.authorization.reports"></i>
                                    <i class="fa fa-minus text-danger" ng-if="!item.authorization.reports"></i>
                                </dd>
                                <dt>Ayar Yönetimi : </dt>
                                <dd>
                                    <i class="fa fa-plus text-success" ng-if="item.authorization.settings"></i>
                                    <i class="fa fa-minus text-danger" ng-if="!item.authorization.settings"></i>
                                </dd>
                            </dl>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-responsive" ng-if="data.users.data.length == 0">
            <div class="alert alert-default pastel">
                <i class="fa fa-info pr10"></i>
                <strong>
                    Kayıtlı Yetkiliınız bulunamadı! <a href="/yeni-yetkili">Buraya</a> tıklayarak yeni Yetkili kaydı oluşturubilirsiniz.
                </strong>
            </div>
        </div>
    </div>
    <div ng-include="'modules/company/users/modal.html'"></div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>